<template>
  <span v-resize="checkMobile">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <!-- <v-flex md12>
          <h2>{{ $t('custom.analitics') }}</h2>
        </v-flex> -->
    <v-container fluid fill-height>
      <!-- <v-layout> -->

      <v-toolbar
        text
        :color="$vuetify.theme.dark ? '' : 'white'"
        class="align-center"
      >
        <v-toolbar-title
          >{{ $t("analitics.common_bookings") }} {{ $t("custom.number")
          }}{{ report.id }} {{ start_date_formatted }} -
          {{ end_date_formatted }} ({{ getBranchName() }})</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mr-2"
          icon
          @click="recalculateReport"
          :title="$t('analitics.recalculate')"
          :loading="isRecalculating"
          :disabled="isRecalculating || isGenerating"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn
          icon
          :href="`https://rentprog.${
            $root.$i18n.locale == 'ru' ? 'ru' : 'com'
          }/${$root.$i18n.locale}/categories/8/guides/25`"
          target="_blank"
        >
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      
      <!-- Индикатор генерации отчета -->
      <v-flex v-if="isGenerating && !generationError" md12 class="mb-4 mt-4">
        <v-alert type="info" border="left" colored-border class="mb-4">
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generating') }}</div>
              <div class="text-caption">
                <span v-if="connected" class="success--text">● {{ $t('analitics.connected') }}</span>
                <span v-else class="error--text">● {{ $t('analitics.disconnected') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-progress-linear :value="reportProgress" color="primary" height="20" class="mt-3" striped>
            <template v-slot:default><strong>{{ reportProgress.toFixed(0) }}%</strong></template>
          </v-progress-linear>
        </v-alert>
      </v-flex>
      
      <!-- Ошибка генерации отчета -->
      <v-flex v-if="generationError" md12 class="mb-4 mt-4">
        <v-alert type="error" border="left" colored-border class="mb-4">
          <v-row align="center">
            <v-col class="grow">
              <div class="text-h6">{{ $t('analitics.report_generation_error') }}</div>
              <div class="text-body-2 mt-2">{{ generationError }}</div>
            </v-col>
          </v-row>
          <v-btn color="error" outlined class="mt-3" @click="retryGeneration">
            <v-icon left>mdi-refresh</v-icon>
            {{ $t('analitics.try_again') }}
          </v-btn>
        </v-alert>
      </v-flex>
      
      <!-- По машинам -->
      <v-flex v-if="report.state == 'created'" md12 class="d-inline-flex">
        <v-flex md12 class="mt-2">
          <!-- Визуальная аналитика -->
          <v-card-text v-if="showCharts">
            <v-expansion-panels v-model="chartsPanel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <span class="subtitle-1 font-weight-medium">
                    <v-icon left color="primary">mdi-chart-bar</v-icon>
                    {{ $t("analitics.visual_analytics") }}
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-flex md12>
                    <h2>{{ $t("analitics.booking_states") }}</h2>
                  </v-flex>
                  <v-flex md12 sm12 :class="isMobile ? '' : 'd-flex'">
              <v-flex md6 sm12>
                <GChart
                  v-if="pie_chart_all_states_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="PieChart"
                  :options="pie_chart_all_states_options"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="pie_chart_all_states_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
              <v-flex md6 sm12>
                <GChart
                  v-if="pie_chart_active_states_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="PieChart"
                  :options="pie_chart_active_states_options"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="pie_chart_active_states_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
            </v-flex>
            <v-flex md12>
              <h2>{{ $t("car_classes.car_classes") }}</h2>
            </v-flex>
            <v-flex md12 sm12 :class="isMobile ? '' : 'd-flex'">
              <v-flex md6 sm12>
                <GChart
                  v-if="pie_chart_car_classes_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="PieChart"
                  :options="pie_chart_all_classes_options"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="pie_chart_car_classes_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
              <v-flex md6 sm12>
                <GChart
                  v-if="pie_chart_car_classes_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="PieChart"
                  :options="pie_chart_active_classes_options"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="pie_chart_car_classes_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
            </v-flex>
            <v-flex md12>
              <h2>{{ $t("analitics.prices_classes") }}</h2>
            </v-flex>
            <v-flex md12 sm12 :class="isMobile ? '' : 'd-flex'">
              <v-flex md6 sm12>
                <GChart
                  v-if="line_chart_all_prices_econom_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="LineChart"
                  :options="lineChartEconomOptions"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="line_chart_all_prices_econom_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
              <v-flex md6 sm12>
                <GChart
                  v-if="line_chart_all_prices_middle_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="LineChart"
                  :options="lineChartMiddleOptions"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="line_chart_all_prices_middle_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
            </v-flex>
            <v-flex md12 sm12 :class="isMobile ? '' : 'd-flex'">
              <v-flex md6 sm12>
                <GChart
                  v-if="line_chart_all_prices_business_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="LineChart"
                  :options="lineChartBusinessOptions"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="line_chart_all_prices_business_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
              <v-flex md6 sm12>
                <GChart
                  v-if="line_chart_all_prices_comercial_data.length > 1"
                  style="width: 100%; min-height: 300px"
                  type="LineChart"
                  :options="lineChartCommercialOptions"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="line_chart_all_prices_comercial_data"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
            </v-flex>
            <v-flex md12 class="mt-4">
              <h2>{{ $t("analitics.additional_analytics") }}</h2>
            </v-flex>
            <v-flex md12 sm12 :class="isMobile ? '' : 'd-flex'">
              <!-- Топ-10 автомобилей по бронированиям -->
              <v-flex md6 sm12>
                <GChart
                  v-if="topCarsBookingsData.length > 1"
                  style="width: 100%; min-height: 400px"
                  type="BarChart"
                  :options="topCarsBookingsOptions"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="topCarsBookingsData"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>

              <!-- Конверсия по классам -->
              <v-flex md6 sm12>
                <GChart
                  v-if="conversionByClassData.length > 1"
                  style="width: 100%; min-height: 400px"
                  type="ColumnChart"
                  :options="conversionByClassOptions"
                  :settings="{
                    packages: ['corechart'],
                    language: this.$i18n.locale,
                  }"
                  :data="conversionByClassData"
                />
                <v-flex class="mt-16 text-center" v-else>
                  {{ $t("analitics.no_data") }}
                </v-flex>
              </v-flex>
            </v-flex>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-card-text>
            <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
              <h2>{{ $t("analitics.average_indicators") }}</h2>
            </v-toolbar>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      {{ $t("analitics.all_bookings") }}
                    </th>
                    <th class="text-center">
                      {{ $t("analitics.active_bookings") }}
                    </th>
                    <th class="text-center">
                      {{ $t("analitics.convertion") }}
                    </th>
                    <th class="text-center">
                      {{ $t("analitics.average_price_econom") }}
                    </th>
                    <th class="text-center">
                      {{ $t("analitics.average_price_middle") }}
                    </th>
                    <th class="text-center">
                      {{ $t("analitics.average_price_business") }}
                    </th>
                    <th class="text-center">
                      {{ $t("analitics.average_price_comercial") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-center">
                      {{ report.bookings }}
                    </td>
                    <td class="text-center">
                      {{ report.active_bookings }}
                    </td>
                    <td class="text-center">
                      {{ parseFloat(report.convertion).toFixed(2) }}%
                    </td>
                    <td class="text-center">
                      {{
                        parseFloat(
                          averagePrice(all_prices_econom_data)
                        ).toFixed(2)
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        parseFloat(
                          averagePrice(all_prices_middle_data)
                        ).toFixed(2)
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        parseFloat(
                          averagePrice(all_prices_business_data)
                        ).toFixed(2)
                      }}
                    </td>
                    <td class="text-center">
                      {{
                        parseFloat(
                          averagePrice(all_prices_comercial_data)
                        ).toFixed(2)
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-text>
            <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
              <h2 class="mb-2">{{ $t("analitics.for_bookings") }}</h2>
            </v-toolbar>
            <v-data-table
              :class="!isMobile ? 'mt-5' : 'mt-5 is-mobile'"
              dense
              :headers="headers"
              :items="cars_data"
              :loading="isLoading"
              :loading-text="$t('custom.loading_table')"
              :search="search"
              :items-per-page="50"
              :sort-by="['created_at']"
              mobile-breakpoint="100"
              :sort-desc="[true]"
              :footer-props="{
                ...tableFooterProps([50, 100, -1]),
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
              }"
            >
              <template slot="item" slot-scope="props">
                <tr
                  @dblclick="replaceToCar(props.item.car_id)"
                  :class="props.item.active ? '' : 'grey--text text--lighten-1'"
                >
                  <td nowrap class="text-center">
                    <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{
                      props.item.code
                    }}</router-link>
                  </td>
                  <td nowrap class="text-center">
                    {{ selectClassLocale(props.item.car_class) }}
                  </td>
                  <td nowrap class="text-center">
                    {{ formattedDate(props.item.buy_date) }}
                  </td>
                  <td nowrap class="text-center">
                    {{ props.item.bookings_size }}
                  </td>
                  <td nowrap class="text-center">
                    {{ props.item.active_bookings_size }}
                  </td>
                  <td nowrap class="text-center">
                    {{
                      parseFloat(props.item.all_bookings_average_price).toFixed(
                        2
                      )
                    }}
                  </td>
                  <td nowrap class="text-center">
                    {{
                      parseFloat(
                        props.item.active_bookings_average_price
                      ).toFixed(2)
                    }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-flex>
      </v-flex>
      <v-flex v-else md12 class="text-center mt-10">
        {{ $t("analitics.report_in_progress") }}
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <br />
        <v-btn @click="$router.go()">{{ $t("custom.update") }}</v-btn>
      </v-flex>
    </v-container>
  </span>
</template>
<script>
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { GChart } from "vue-google-charts";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
import CableSubscriber from "@/mixins/CableSubscriber";
export default {
  mixins: [CableSubscriber],
  data() {
    return {
      report: {},
      showCharts: false,
      chartsPanel: [0],
      cars_data: [],
      all_states_data: [],
      active_states_data: [],
      car_classes_data: [],
      car_active_classes_data: [],
      all_prices_data: [],
      // WebSocket статус
      isGenerating: false,
      isRecalculating: false,
      connected: false,
      reportProgress: 0,
      generationError: null,
      all_prices_econom_data: [],
      all_prices_middle_data: [],
      all_prices_business_data: [],
      all_prices_comercial_data: [],
      headers: [
        { text: this.$t("custom.car"), value: "code", align: "center" },
        {
          text: this.$t("analitics.car_class"),
          value: "car_class",
          align: "center",
        },
        {
          text: this.$t("cars.purchase_date"),
          value: "buy_date",
          align: "center",
        },
        {
          text: this.$t("analitics.all_bookings_2"),
          value: "bookings_size",
          align: "center",
        },
        {
          text: this.$t("analitics.active_bookings_2"),
          value: "active_bookings_size",
          align: "center",
        },
        {
          text: this.$t("analitics.all_bookings_average_price"),
          value: "all_bookings_average_price",
          align: "center",
        },
        {
          text: this.$t("analitics.active_bookings_average_price"),
          value: "active_bookings_average_price",
          align: "center",
        },
      ],
      pie_chart_all_states_data: [
        [this.$t("analitics.in_all_bookings"), this.$t("custom.sum")],
      ],
      pie_chart_active_states_data: [
        [this.$t("analitics.in_active_bookings"), this.$t("custom.sum")],
      ],
      pie_chart_car_classes_data: [
        [this.$t("analitics.in_all_bookings"), this.$t("custom.sum")],
      ],
      pie_chart_car_active_classes_data: [
        [this.$t("analitics.in_active_bookings"), this.$t("custom.sum")],
      ],
      line_chart_all_prices_econom_data: [
        [
          this.$t("analitics.in_all_bookings"),
          this.$t("analitics.prices_classes"),
        ],
      ],
      line_chart_all_prices_middle_data: [
        [
          this.$t("analitics.in_all_bookings"),
          this.$t("analitics.prices_classes"),
        ],
      ],
      line_chart_all_prices_business_data: [
        [
          this.$t("analitics.in_all_bookings"),
          this.$t("analitics.prices_classes"),
        ],
      ],
      line_chart_all_prices_comercial_data: [
        [
          this.$t("analitics.in_all_bookings"),
          this.$t("analitics.prices_classes"),
        ],
      ],
      search: "",
      isLoading: false,
      error: "",
      // Данные о филиалах
      branches: [],
      current_branch_name: ''
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  beforeDestroy() {
    this.unsubscribeFromReport()
  },
  created() {
    setMomentLocale(this.$i18n.locale);
    if (
      this.$store.getters.isLoggedIn &&
      (this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isGuest)
    ) {
      this.isLoading = true;
      this.loadReport();
    } else {
      this.$router.push({ path: `/dashboard` }).catch((err) => {});
      this.$notify(this.$t("errors.only_admins"), "", "warning", 5000);
    }
  },
  watch: {},
  computed: {
    start_date_formatted() {
      return moment(this.report.start_date).format("DD.MM.YYYY");
    },
    end_date_formatted() {
      return moment(this.report.end_date).format("DD.MM.YYYY");
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    // === Опции графиков с адаптацией под тему ===
    pie_chart_all_states_options() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.in_all_bookings"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    pie_chart_active_states_options() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.in_active_bookings"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    pie_chart_all_classes_options() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.in_all_bookings"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    pie_chart_active_classes_options() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.in_active_bookings"),
        pieHole: 0.4,
        sliceVisibilityThreshold: 0.00014,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
      };
    },
    lineChartEconomOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t('analitics.prices_for_car_econom'),
        curveType: 'function',
        lineWidth: 2,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#4CAF50"],
      };
    },
    lineChartMiddleOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t('analitics.prices_for_car_middle'),
        curveType: 'function',
        lineWidth: 2,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3"],
      };
    },
    lineChartBusinessOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t('analitics.prices_for_car_business'),
        curveType: 'function',
        lineWidth: 2,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#FF9800"],
      };
    },
    lineChartCommercialOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t('analitics.prices_for_car_comercial'),
        curveType: 'function',
        lineWidth: 2,
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#9C27B0"],
      };
    },
    // === Новые графики ===
    topCarsBookingsOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.top_cars_by_bookings"),
        chartArea: { width: "60%" },
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          title: this.$t("analitics.bookings_count"),
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#4CAF50"],
      };
    },
    topCarsBookingsData() {
      if (!this.cars_data || this.cars_data.length === 0) return [];
      const data = [[this.$t("custom.car"), this.$t("analitics.bookings_count")]];
      const sorted = [...this.cars_data]
        .sort((a, b) => b.bookings_size - a.bookings_size)
        .slice(0, 10);
      sorted.forEach((car) => {
        data.push([car.code, Number(car.bookings_size) || 0]);
      });
      return data;
    },
    conversionByClassOptions() {
      const isDark = this.$vuetify.theme.dark;
      return {
        title: this.$t("analitics.conversion_by_class"),
        titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        backgroundColor: isDark ? "#1E1E1E" : "#FFFFFF",
        legend: { position: "none" },
        hAxis: {
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        vAxis: {
          title: this.$t("analitics.convertion") + " (%)",
          textStyle: { color: isDark ? "#FFFFFF" : "#000000" },
          titleTextStyle: { color: isDark ? "#FFFFFF" : "#000000" },
        },
        colors: ["#2196F3"],
      };
    },
    conversionByClassData() {
      if (!this.car_classes_data || this.car_classes_data.length === 0) return [];
      const data = [[this.$t("analitics.car_class"), this.$t("analitics.convertion")]];
      
      // Подсчитываем конверсию по классам
      const classMap = {};
      this.car_classes_data.forEach((item) => {
        if (!classMap[item.car_class]) {
          classMap[item.car_class] = { all: 0, active: 0 };
        }
        classMap[item.car_class].all = item.count;
      });
      
      this.car_active_classes_data.forEach((item) => {
        if (!classMap[item.car_class]) {
          classMap[item.car_class] = { all: 0, active: 0 };
        }
        classMap[item.car_class].active = item.count;
      });
      
      Object.keys(classMap).forEach((carClass) => {
        const conversion = classMap[carClass].all > 0
          ? ((classMap[carClass].active / classMap[carClass].all) * 100).toFixed(2)
          : 0;
        data.push([this.selectClassLocale(carClass), parseFloat(conversion)]);
      });
      
      return data;
    },
  },
  methods: {
    getBranchName() {
      if (this.report.all_branches) {
        return this.$t('custom.all_branches');
      }
      
      if (this.report.company_id) {
        const branch = this.branches.find(b => b.id === this.report.company_id);
        return branch ? branch.name : this.current_branch_name;
      }
      
      return this.current_branch_name;
    },
    loadReport() {
      this.axios
        .get(`/api/v1/bookings_reports/${this.$route.params.query}`, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then((response) => {
          this.report = response.data;
          this.branches = response.data.branches || [];
          this.current_branch_name = response.data.current_branch_name || '';
          if (this.report.state === 'initial' || this.report.state === 'pending') {
            this.isGenerating = true
            this.subscribeToReportUpdates()
          }
          if (response.data.state == "created") {
            this.cars_data = response.data.cars_data;
            this.all_states_data = response.data.all_states_data;
            this.active_states_data = response.data.active_states_data;
            this.car_classes_data = response.data.car_classes_data;
            this.car_active_classes_data = response.data.car_active_classes_data;
            this.all_prices_data = response.data.all_prices;
            
            // Преобразуем данные в формат Google Charts
            this.prepareChartData();
            
            this.showCharts = true;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.bookings_report_load"));
          console.log(error);
          this.isLoading = false;
        });
    },
    // FT-066: ReportsChannel handlers (moved from the old channels option; this-rebinding via
    // arrows in subscribeToReportUpdates). Bodies are 1:1 with the former declarative channel.
    onReportConnected() {
      this.connected = true
    },
    onReportDisconnected() {
      this.connected = false
    },
    onReportReceived(data) {
      if (data.report_id === this.report.id) {
        this.reportProgress = data.progress

        if (data.status === 'completed') {
          this.isGenerating = false
          this.loadReport()

          this.$notify(
            this.$t('analitics.report_ready'),
            this.$t('analitics.report_generated_successfully'),
            'success',
            5000
          )
        }

        if (data.status === 'failed') {
          this.isGenerating = false
          this.generationError = data.error || this.$t('analitics.report_generation_failed')

          this.$notify(this.$t('errors.error'), this.generationError, 'error', 5000)
        }
      }
    },

    subscribeToReportUpdates() {
      if (this.report && this.report.id) {
        // FT-066 switch pattern: drop any prior sub before re-subscribing.
        this.$cableUnsubscribe(this.reportSub)
        this.reportSub = this.$cableSubscribe(
          {
            channel: 'ReportsChannel',
            report_type: 'bookings',
            report_id: this.report.id
          },
          {
            connected: () => this.onReportConnected(),
            disconnected: () => this.onReportDisconnected(),
            received: (data) => this.onReportReceived(data)
          }
        )
      }
    },
    unsubscribeFromReport() {
      this.$cableUnsubscribe(this.reportSub)
      this.reportSub = null
    },
    
    recalculateReport() {
      if (!this.report || !this.report.id || this.isRecalculating) {
        return
      }

      this.isRecalculating = true
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0

      this.unsubscribeFromReport()

      this.axios
        .post(`/api/v1/bookings_reports/${this.report.id}/recalculate`, {}, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then(() => {
          if (this.report) {
            this.report.state = 'pending'
          }
          this.subscribeToReportUpdates()
          this.$notify(
            this.$t('analitics.report_recalculation_started'),
            '',
            'success',
            3000
          )
        })
        .catch((error) => {
          this.isGenerating = false
          const message =
            (error.response && error.response?.data && error.response?.data.error) ||
            this.$t('analitics.report_recalculation_failed')
          let localizedMessage = message
          if (message === 'Report is already being processed') {
            localizedMessage = this.$t('analitics.report_already_processing')
          }
          this.generationError = localizedMessage
          this.$notify(this.$t('errors.error'), localizedMessage, 'error', 5000)
        })
        .finally(() => {
          this.isRecalculating = false
        })
    },

    retryGeneration() {
      // Сбрасываем ошибку и перезагружаем отчет
      this.generationError = null
      this.isGenerating = true
      this.reportProgress = 0
      this.loadReport()
    },
    
    prepareChartData() {
      // Статусы всех броней
      this.pie_chart_all_states_data = [
        [this.$t("analitics.in_all_bookings"), this.$t("custom.sum")]
      ];
      if (this.all_states_data && this.all_states_data.length > 0) {
        this.all_states_data.forEach((item) => {
          this.pie_chart_all_states_data.push([
            this.selectStateLocale(item.state),
            item.count
          ]);
        });
      }

      // Статусы активных броней
      this.pie_chart_active_states_data = [
        [this.$t("analitics.in_active_bookings"), this.$t("custom.sum")]
      ];
      if (this.active_states_data && this.active_states_data.length > 0) {
        this.active_states_data.forEach((item) => {
          this.pie_chart_active_states_data.push([
            this.selectStateLocale(item.state),
            item.count
          ]);
        });
      }

      // Классы машин - все брони
      this.pie_chart_car_classes_data = [
        [this.$t("analitics.in_all_bookings"), this.$t("custom.sum")]
      ];
      if (this.car_classes_data && this.car_classes_data.length > 0) {
        this.car_classes_data.forEach((item) => {
          this.pie_chart_car_classes_data.push([
            this.selectClassLocale(item.car_class),
            item.count
          ]);
        });
      }

      // Классы машин - активные брони
      this.pie_chart_car_active_classes_data = [
        [this.$t("analitics.in_active_bookings"), this.$t("custom.sum")]
      ];
      if (this.car_active_classes_data && this.car_active_classes_data.length > 0) {
        this.car_active_classes_data.forEach((item) => {
          this.pie_chart_car_active_classes_data.push([
            this.selectClassLocale(item.car_class),
            item.count
          ]);
        });
      }

      // Обработка цен по классам
      if (this.all_prices_data && this.all_prices_data.length > 0) {
        // Инициализация массивов для линейных графиков
        this.line_chart_all_prices_econom_data = [
          [this.$t("analitics.in_all_bookings"), this.$t("analitics.prices_classes")]
        ];
        this.line_chart_all_prices_middle_data = [
          [this.$t("analitics.in_all_bookings"), this.$t("analitics.prices_classes")]
        ];
        this.line_chart_all_prices_business_data = [
          [this.$t("analitics.in_all_bookings"), this.$t("analitics.prices_classes")]
        ];
        this.line_chart_all_prices_comercial_data = [
          [this.$t("analitics.in_all_bookings"), this.$t("analitics.prices_classes")]
        ];

        // Разделяем данные по классам
        this.all_prices_econom_data = [];
        this.all_prices_middle_data = [];
        this.all_prices_business_data = [];
        this.all_prices_comercial_data = [];

        this.all_prices_data.forEach((price_item) => {
          const [date, price, car_class] = price_item;
          
          // Парсим дату с учетом формата "DD-MM-YYYY HH:MM" или ISO формата
          let formattedDate;
          if (date && date.includes('-') && !date.includes('T')) {
            // Формат "DD-MM-YYYY HH:MM"
            formattedDate = moment(date, "DD-MM-YYYY HH:mm").format("DD.MM.YYYY");
          } else {
            // ISO формат или другой стандартный формат
            formattedDate = moment(date).format("DD.MM.YYYY");
          }
          
          // Проверяем, что дата валидна
          if (formattedDate === "Invalid date") {
            return; // Пропускаем невалидные даты
          }
          
          if (car_class === "Эконом") {
            this.all_prices_econom_data.push(price);
            this.line_chart_all_prices_econom_data.push([formattedDate, price]);
          } else if (car_class === "Средний") {
            this.all_prices_middle_data.push(price);
            this.line_chart_all_prices_middle_data.push([formattedDate, price]);
          } else if (car_class === "Бизнес") {
            this.all_prices_business_data.push(price);
            this.line_chart_all_prices_business_data.push([formattedDate, price]);
          } else if (car_class === "Коммерческий") {
            this.all_prices_comercial_data.push(price);
            this.line_chart_all_prices_comercial_data.push([formattedDate, price]);
          }
        });
      }
    },
    selectStateLocale(state) {
      if (state == "Недозвон") {
        return this.$t("bookings_states.abandoned");
      } else if (state == "Подтверждена") {
        return this.$t("bookings_states.accepted");
      } else if (state == "Активная") {
        return this.$t("bookings_states.active");
      } else if (state == "Отмена") {
        return this.$t("bookings_states.cancel");
      } else if (state == "Отказ клиента") {
        return this.$t("bookings_states.decline");
      } else if (state == "В обработке") {
        return this.$t("bookings_states.in_work");
      } else if (state == "Новая") {
        return this.$t("bookings_states.new");
      } else if (state == "Нет машин") {
        return this.$t("bookings_states.no_cars");
      } else if (state == "Не подтверждена") {
        return this.$t("bookings_states.not_accepted");
      } else if (state == "Другое") {
        return this.$t("bookings_states.other");
      } else if (state == "Вернуть залог") {
        return this.$t("bookings_states.return_deposit");
      } else if (state == "Отъездила") {
        return this.$t("bookings_states.rided");
      } else if (state == "Ожидает ответа клиента") {
        return this.$t("bookings_states.wait_answer");
      } else if (state == "Ожидает оплаты") {
        return this.$t("bookings_states.wait_pay");
      } else {
        return "???";
      }
    },
    selectClassLocale(car_class) {
      if (car_class == "Бизнес") {
        return this.$t("car_classes.business");
      } else if (car_class == "Коммерческий") {
        return this.$t("car_classes.commercial");
      } else if (car_class == "Эконом") {
        return this.$t("car_classes.economy");
      } else if (car_class == "Средний") {
        return this.$t("car_classes.middle");
      } else {
        return "???";
      }
    },
    averagePrice(array) {
      if (array.length > 0) {
        return array.reduce((a, b) => a + b, 0) / array.length;
      } else {
        return 0;
      }
    },
    replaceToCar(car) {
      this.$router.push({ path: `/cars/${car.id}` });
    },
    formattedDate(date) {
      return date ? moment(date).format("ll") : "-";
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    GChart,
  },
};
</script>
<style>
  .is-mobile .v-data-footer__select {
    margin-right: 0 !important;
  }
  .is-mobile .v-data-footer__icons-before {
    margin: 0 auto !important;
  }
  .is-mobile .v-data-footer__icons-after {
    margin: 0 auto !important;
  }
</style>
